/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlZeroDayAlertUploadJobStatus = {
    Pending: 'pending',
    Processing: 'processing',
    Completed: 'completed',
    Failed: 'failed'
} as const;
export type ControlZeroDayAlertUploadJobStatus = typeof ControlZeroDayAlertUploadJobStatus[keyof typeof ControlZeroDayAlertUploadJobStatus];


export function ControlZeroDayAlertUploadJobStatusFromJSON(json: any): ControlZeroDayAlertUploadJobStatus {
    return ControlZeroDayAlertUploadJobStatusFromJSONTyped(json, false);
}

export function ControlZeroDayAlertUploadJobStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlZeroDayAlertUploadJobStatus {
    return json as ControlZeroDayAlertUploadJobStatus;
}

export function ControlZeroDayAlertUploadJobStatusToJSON(value?: ControlZeroDayAlertUploadJobStatus | null): any {
    return value as any;
}

